import { mapfreCondizioniGeneraliContratto } from '../../components/buy/utils'
import * as types from '../../constants/ActionTypes'
import { fetchData, fetching } from '../Buy'

const createBasicCreator = actionType => payload => ({
  type: actionType,
  payload,
})

const fetch_postClienti = fetchData

const fetch_putClienti = actionType => payload => {
  function build_put_body(cliente) {
    const clienti_available_fields = [
      'cap_consegna',
      'cap_domicilio',
      'cap_fatturazione',
      'cap_residenza',
      'codice_cittadinanza',
      'codice_fiscale',
      'codice_nazione_nascita',
      'codice_provincia_consegna',
      'codice_provincia_domicilio',
      'codice_provincia_fatturazione',
      'codice_provincia_nascita',
      'codice_provincia_residenza',
      'cognome',
      'comune_consegna',
      'comune_domicilio',
      'comune_fatturazione',
      'comune_nascita',
      'comune_residenza',
      'condizioni_brumbrum_obbligatorie',
      'data_di_nascita',
      'data_rilascio_permesso_soggiorno',
      'data_scadenza_permesso_soggiorno',
      'domicilio_diverso',
      'email',
      'indirizzo_consegna',
      'indirizzo_domicilio',
      'indirizzo_fatturazione',
      'indirizzo_residenza',
      'informativa_trattamento_dati_personali_garanzia',
      'nome',
      'numero_civico_consegna',
      'numero_civico_domicilio',
      'numero_civico_fatturazione',
      'numero_civico_residenza',
      'partita_iva',
      'permesso_soggiorno',
      'ragione_sociale',
      'sesso',
      'telefono',
    ]

    // BRUM-7336 abilita documenti per findomestic
    // if (!isFindomestic(state.product)) {
    clienti_available_fields.push(
      'documento',
      'data_rilascio_documento',
      'ente_rilascio_documento',
      'numero_documento'
    )
    // }

    const body = {
      fields: [],
    }

    Object.keys(cliente).map(key => {
      if (clienti_available_fields.indexOf(key) !== -1) {
        switch (key) {
          case 'comune_nascita':
            if (
              (typeof cliente[key] === 'string' ||
                cliente[key] instanceof String) &&
              cliente[key].indexOf('|') > -1
            ) {
              const splitted = cliente[key].split('|')
              if (splitted[0] !== 'null') {
                body.fields.push({
                  type: 'comune_nascita',
                  value: splitted[0],
                })
              }
              if (splitted[1] !== 'null') {
                body.fields.push({
                  type: 'codice_provincia_nascita',
                  value: splitted[1],
                })
              }
              if (splitted[2] !== 'null') {
                body.fields.push({
                  type: 'codice_nazione_nascita',
                  value: splitted[2],
                })
              }
            } else {
              body.fields.push({
                type: key,
                value: cliente[key],
              })
            }
            break

          case 'data_rilascio_permesso_soggiorno':
            if (cliente.tipo_permesso_soggiorno === 'unlimited') {
              body.fields.push({
                type: key,
                value: '2021-01-01',
              })
              break
            }

          case 'data_scadenza_permesso_soggiorno':
            if (cliente.tipo_permesso_soggiorno === 'unlimited') {
              body.fields.push({
                type: key,
                value: '2099-12-31',
              })
              break
            }

          case 'data_di_nascita':
          case 'data_rilascio_documento':
            if (Object.keys(cliente[key]).length === 4) {
              // this stuff needs to be done because after restoring from db, the preceding 0 is removed during json_encode
              let month = cliente[key].month.toString()
              month = `0${month}`
              month = month.slice(-2)
              let day = cliente[key].day.toString()
              day = `0${day}`
              day = day.slice(-2)
              body.fields.push({
                type: key,
                value: `${cliente[key].year}-${month}-${day}`,
              })
            }
            break

          case 'condizioni_brumbrum_obbligatorie':
            if (cliente[key] === 1 || cliente[key] === '1') {
              body.fields.push({
                type: key,
                value: cliente[key],
              })
              body.fields.push({
                type: 'cgc_link',
                value: mapfreCondizioniGeneraliContratto,
              })
            }
            break

          case 'ente_rilascio_documento':
            body.fields.push({
              type: key,
              value:
                cliente[key].split('|').length >= 3
                  ? cliente[key].split('|')[3]
                  : cliente[key].split('|')[0],
            })
            break

          case 'permesso_soggiorno':
            body.fields.push({
              type: key,
              value: cliente[key] ? 1 : 0,
            })
            break

          case 'cap_domicilio':
          case 'numero_civico_domicilio':
          case 'indirizzo_domicilio':
            if (
              cliente.domicilio_diverso === '1' ||
              cliente.domicilio_diverso === 1 ||
              cliente.domicilio_diverso === true
            ) {
              body.fields.push({
                type: key,
                value: cliente[key],
              })
            }
            break
          case 'comune_domicilio':
          case 'codice_provincia_domicilio':
            // non vanno inviate a backend, ci pensa citta_domicilio
            break
          case 'citta_domicilio':
            if (
              cliente.domicilio_diverso === '1' ||
              cliente.domicilio_diverso === 1 ||
              cliente.domicilio_diverso === true
            ) {
              if (
                cliente.citta_domicilio &&
                cliente.citta_domicilio.length > 0
              ) {
                const splitted = cliente.citta_domicilio.split('|')
                body.fields.push({
                  type: 'comune_domicilio',
                  value: splitted[0] || null,
                })
                body.fields.push({
                  type: 'codice_provincia_domicilio',
                  value: splitted[1] || null,
                })
              }
            }
            break

          default:
            body.fields.push({
              type: key,
              value: cliente[key],
            })
            break
        }
      }

      return null
    })

    if (cliente.cittadinanza && cliente.cittadinanza.length > 1) {
      body.fields.push({
        type: 'codice_cittadinanza',
        value: cliente.cittadinanza.split('|')[0],
      })
    }

    if (cliente.phone && cliente.phone.toString().length > 0) {
      body.fields.push({
        type: 'telefono',
        value: cliente.phone,
      })
    }

    if (cliente.citta_residenza && cliente.citta_residenza.length > 0) {
      const splitted = cliente.citta_residenza.split('|')
      body.fields.push({
        type: 'comune_residenza',
        value: splitted[0] || null,
      })
      body.fields.push({
        type: 'codice_provincia_residenza',
        value: splitted[1] || null,
      })
    }

    if (cliente.citta_consegna && cliente.citta_consegna.length > 0) {
      const splitted = cliente.citta_consegna.split('|')
      body.fields.push({
        type: 'comune_consegna',
        value: splitted[0] || null,
      })
      body.fields.push({
        type: 'codice_provincia_consegna',
        value: splitted[1] || null,
      })
    }

    if (
      cliente.domicilio_diverso === '1' ||
      cliente.domicilio_diverso === 1 ||
      cliente.domicilio_diverso === true
    ) {
      if (cliente.citta_domicilio && cliente.citta_domicilio.length > 0) {
        const splitted = cliente.citta_domicilio.split('|')
        body.fields.push({
          type: 'comune_domicilio',
          value: splitted[0] || null,
        })
        body.fields.push({
          type: 'codice_provincia_domicilio',
          value: splitted[1] || null,
        })
      }
    } else {
      // patch per evitare il bug BRUM-7834
      // rimuovo cap_domicilio quando il domicilio non e' diverso dalla residenza
      delete body.fields.cap_domicilio
    }

    if (cliente.citta_fatturazione && cliente.citta_fatturazione.length > 0) {
      const splitted = cliente.citta_fatturazione.split('|')
      body.fields.push({
        type: 'comune_fatturazione',
        value: splitted[0] || null,
      })
      body.fields.push({
        type: 'codice_provincia_fatturazione',
        value: splitted[1] || null,
      })
    }

    if (cliente.civico_domicilio) {
      body.fields.push({
        type: 'numero_civico_domicilio',
        value: cliente.civico_domicilio,
      })
    }

    if (cliente.civico_consegna) {
      body.fields.push({
        type: 'numero_civico_consegna',
        value: cliente.civico_consegna,
      })
    }

    if (cliente.civico_fatturazione) {
      body.fields.push({
        type: 'numero_civico_fatturazione',
        value: cliente.civico_fatturazione,
      })
    }

    if (cliente.id_tracciato && cliente.id_tracciato.length > 0) {
      body.fields.push({
        type: 'id_tracciato',
        value: cliente.id_tracciato,
      })
    }

    return body
  }

  return (dispatch, getState) => {
    dispatch(
      fetching({
        fetching: true,
      })
    )

    dispatch({ type: actionType })

    if (
      payload.cliente.id_cliente === null ||
      payload.cliente.id_cliente === undefined
    ) {
      const postClientiPayload = {
        id_ordine: payload.id_ordine,
      }
      return dispatch(
        postClienti({
          uri: `${window.brumbrum.url_api}/ordini/t/v1/clienti/`,
          method: 'POST',
          body: postClientiPayload,
          callback: postClientiCallback,
          id_ordine: payload.id_ordine,
        })
      ).then(json => {
        /**
         * spread operator
         * non funziona con jest
         * https://developer.mozilla.org/it/docs/Web/JavaScript/Reference/Operators/Spread_operator
         */
        //        const new_payload = deepAssign( {}, payload, { cliente: { id_cliente: json.result } } )
        //        const new_cliente = { ...payload.cliente, ...{ id_cliente: json.result } }
        //        const new_payload = { ...payload, ...new_cliente }
        const new_cliente = { ...payload.cliente, id_cliente: json.result }
        const new_payload = { ...payload, cliente: new_cliente }
        return dispatch(fetch_putClienti(actionType)(new_payload))
      })
    }

    const uri = `${window.brumbrum.url_api}/ordini/t/v1/clienti/${payload.cliente.id_cliente}`

    payload.method = 'PUT'
    payload.uri = uri
    payload.body = build_put_body(payload.cliente, getState())

    return fetchData(actionType)(payload)(dispatch, getState)
  }
}

export const fetchPutClienti = fetch_putClienti
export const putClienti = fetch_putClienti(types.PUT_CLIENTI)
export const putClientiCallback = createBasicCreator(types.PUT_CLIENTI_CALLBACK)
export const postClienti = fetch_postClienti(types.POST_CLIENTI)
export const postClientiCallback = createBasicCreator(
  types.POST_CLIENTI_CALLBACK
)
export const tracciatoSent = createBasicCreator(types.TRACCIATO_SENT)
